import { Column, Flex } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";

export const FAOuterWrapper = styled(Column).attrs({
  align: "center",
  justify: "center",
})<{ $bgColor?: string }>`
  width: 100%;
  ${({ $bgColor }) =>
    $bgColor
      ? css`
          background-color: ${$bgColor};
        `
      : null}
`;

const InnerWrapperStyles = css`
  width: 100%;
  max-width: 1245px;
  padding: ${getSpacing("9x", 100)};

  ${responsiveMediaQueries.tabletAndBelow} {
    padding: ${getSpacing("4x", "3x")};
  }
`;

export const FAInnerWrapperColumn = styled(Column)`
  ${InnerWrapperStyles}
`;

export const FAInnerWrapperRow = styled(Flex).attrs({
  direction: { mobileAndAbove: "column", tabletAndAbove: "row" },
})`
  ${InnerWrapperStyles}
`;
